<template>
  <div class="page-shell teacher-home-page">
    <div class="teacher-home-app">
      <MobileTopNav title="名师到家" />

      <main class="teacher-home-main">
        <section class="teacher-home-hero">
          <div class="hero-copy">
            <span class="hero-corner"></span>
            <h1>老师到家</h1>
            <p>查缺补漏、定向培优、拓展拔高</p>
            <small>专业 / 专注 / 专心</small>
          </div>

          <div class="hero-visual">
            <img
              :src="heroIcon"
              alt="名师到家"
            >
            <span class="hero-book"></span>
            <span class="hero-bag"></span>
          </div>
        </section>

        <section class="teacher-home-intro">
          <h2>名师到家课程介绍</h2>
          <p>
            我们会根据学生和家长自身情况，甄别筛选适合学生的老师，到学生家里为学生进行一对一辅导，用轻松的方式，实现学习成绩提升的目标。
          </p>
          <p>
            不同于常规线上教育平台，各地教师，均需经过教师资质认证、专家组考核、现场试讲面授，方可成为签约教师并进行教学，较大程度地保证教学质量。同时，也有别于传统的线下教育机构，打破传统辅导机构收费高、师资不透明的弊端。
          </p>
          <button
            class="teacher-home-action"
            type="button"
            @click="goAppointment"
          >
            在线预约
            <i class="el-icon-right"></i>
          </button>
        </section>

        <section class="teacher-home-feature">
          <h2>课程特色</h2>
          <div class="feature-list">
            <article
              v-for="item in features"
              :key="item.index"
              class="feature-card"
            >
              <div class="feature-index">
                <span>{{ item.index }}</span>
              </div>
              <div class="feature-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </article>
          </div>

          <button
            class="teacher-home-action feature-action"
            type="button"
            @click="goAppointment"
          >
            在线预约
            <i class="el-icon-right"></i>
          </button>
        </section>

        <section class="teacher-home-teachers">
          <div class="teacher-stats-banner">
            <span>10000+优质老师持证上岗</span>
          </div>

          <div class="teacher-source-list">
            <article
              v-for="item in teacherSources"
              :key="item.title"
              class="teacher-source-card"
            >
              <div class="teacher-source-icon" :class="`is-${item.icon}`">
                <span v-if="item.icon === 'board'" class="icon-bulb"></span>
                <span
                  v-else-if="item.icon === 'book'"
                  class="icon-book-stack"
                >
                  <span></span>
                </span>
                <span v-else class="icon-cap"></span>
              </div>
              <h3>{{ item.title }}</h3>
            </article>
          </div>
        </section>

        <section class="teacher-home-process">
          <div class="process-title-wrap">
            <h2>请家教流程</h2>
          </div>

          <div class="process-panel">
            <article
              v-for="item in processSteps"
              :key="item.title"
              class="process-row"
            >
              <div class="process-tag">
                <span class="process-check"></span>
                <strong>{{ item.title }}</strong>
              </div>
              <p>{{ item.desc }}</p>
            </article>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import MobileTopNav from '../components/MobileTopNav.vue'
import { buildUploadAssetUrl } from '../utils/asset'

export default {
  name: 'TeacherHomeView',
  components: {
    MobileTopNav
  },
  data() {
    return {
      heroIcon: buildUploadAssetUrl('icon/1.png'),
      features: [
        {
          index: '1',
          title: '层层把关筛选教师',
          desc: '全国海量多年一线教学经验的老师，层层考核精挑细选。'
        },
        {
          index: '2',
          title: '教师上门个性化教学',
          desc: '家长可根据学生情况与老师邀约合适时间，把老师请到家。'
        },
        {
          index: '3',
          title: '过程透明参与性强',
          desc: '从选择老师到上门授课，家长可全程参与，现场感受了解教学进度。'
        },
        {
          index: '4',
          title: '专属助教全程监管',
          desc: '专属班主任负责，课后及时与家长和老师了解反馈上课情况。'
        }
      ],
      teacherSources: [
        {
          title: '公立、私立、国际学校在职老师',
          icon: 'board'
        },
        {
          title: '新东方、学而思、新航道等机构在职老师',
          icon: 'book'
        },
        {
          title: '985、211等一本院校在校大学生、研究生、博士',
          icon: 'cap'
        }
      ],
      processSteps: [
        {
          title: '了解学生情况',
          desc: '电话或者微信跟课程顾问老师详细沟通孩子情况，了解孩子需要补习的内容和方向以及孩子性格特点。'
        },
        {
          title: '筛选老师',
          desc: '结合孩子特点，精准匹配老师。'
        },
        {
          title: '试讲、定学习计划',
          desc: '课程顾问老师带着老师上门试课，课后老师会根据学生制定合理的学习计划，如果对老师不满意，也可以无条件更换老师。'
        },
        {
          title: '签约稳定授课',
          desc: '跟家长签约，确定长期授课意向。后续学管老师负责长期跟进孩子学习情况。'
        },
        {
          title: '课后跟踪反馈',
          desc: '搭建家长、学员、老师间的桥梁，三方共同配合，让学员收获多多。'
        }
      ]
    }
  },
  mounted() {
    document.title = '名师到家'
  },
  methods: {
    goAppointment() {
      return
      // console.log('预约')
    }
  }
}
</script>

<style scoped>
.teacher-home-page {
  min-height: 100vh;
  background: #f1f2f4;
}

.teacher-home-app {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background: #fff;
}

.teacher-home-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px;
  align-items: center;
  min-height: 225px;
  overflow: hidden;
  background:
    radial-gradient(circle at 16% 6%, rgba(223, 188, 98, 0.22) 0 44px, transparent 45px),
    radial-gradient(circle at 56% 18%, rgba(218, 181, 87, 0.18) 0 34px, transparent 35px),
    linear-gradient(180deg, #fff0b7 0%, #fae8a9 100%);
}

.teacher-home-hero::before,
.teacher-home-hero::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(244, 126, 94, 0.28);
}

.teacher-home-hero::before {
  right: -28px;
  bottom: -32px;
  width: 92px;
  height: 92px;
}

.teacher-home-hero::after {
  left: -28px;
  bottom: -24px;
  width: 70px;
  height: 70px;
}

.hero-copy {
  position: relative;
  z-index: 1;
  margin-left: 28px;
  padding: 22px 0 18px;
  color: #a85c2a;
}

.hero-corner {
  position: absolute;
  top: 4px;
  left: -24px;
  width: 34px;
  height: 34px;
  border-top: 2px solid #b56e3a;
  border-left: 2px solid #b56e3a;
}

.hero-copy h1 {
  width: fit-content;
  padding: 0 10px 8px 0;
  border-bottom: 2px solid #b56e3a;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 2px;
}

.hero-copy p {
  margin-top: 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.6;
}

.hero-copy small {
  display: block;
  margin-top: 10px;
  font-size: 13px;
  letter-spacing: 6px;
}

.hero-visual {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 190px;
}

.hero-visual img {
  position: absolute;
  top: 24px;
  right: 38px;
  z-index: 2;
  width: 42px;
}

.hero-book,
.hero-bag {
  position: absolute;
  display: block;
}

.hero-book {
  top: 34px;
  right: 14px;
  width: 86px;
  height: 118px;
  border-radius: 4px;
  background:
    linear-gradient(#ed6c4d 0 8px, transparent 8px),
    repeating-linear-gradient(180deg, transparent 0 18px, rgba(219, 126, 68, 0.34) 18px 21px),
    #fff7dc;
  box-shadow: -16px 10px 0 #ffe08b;
}

.hero-bag {
  right: 40px;
  bottom: 34px;
  width: 74px;
  height: 58px;
  border-radius: 12px 12px 8px 8px;
  background: linear-gradient(180deg, #8164ba 0%, #584095 100%);
  box-shadow: inset 0 -18px 0 rgba(231, 126, 61, 0.82);
}

.hero-bag::before {
  content: '';
  position: absolute;
  top: -16px;
  left: 22px;
  width: 30px;
  height: 20px;
  border: 5px solid #e8863e;
  border-bottom: none;
  border-radius: 18px 18px 0 0;
}

.teacher-home-intro {
  position: relative;
  padding: 58px 32px 38px;
  overflow: hidden;
  background:
    linear-gradient(45deg, transparent 0 74%, rgba(171, 179, 187, 0.18) 74% 76%, transparent 76%),
    linear-gradient(180deg, #fbfcff 0%, #fff 100%);
}

.teacher-home-intro::after {
  content: '';
  position: absolute;
  left: -48px;
  bottom: -56px;
  width: 170px;
  height: 170px;
  transform: rotate(45deg);
  background: repeating-linear-gradient(
    90deg,
    rgba(119, 129, 139, 0.2) 0 3px,
    transparent 3px 9px
  );
}

.teacher-home-intro h2,
.teacher-home-feature h2,
.teacher-home-process h2 {
  position: relative;
  z-index: 1;
  color: #1f2937;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.4;
}

.teacher-home-intro h2::after {
  content: '';
  display: block;
  width: 116px;
  height: 1px;
  margin-top: 12px;
  background: #222;
}

.teacher-home-intro p {
  position: relative;
  z-index: 1;
  margin-top: 28px;
  color: #7a828d;
  font-size: 18px;
  line-height: 2.05;
  text-align: justify;
  text-indent: 2em;
}

.teacher-home-intro p + p {
  margin-top: 34px;
}

.teacher-home-action {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 166px;
  height: 46px;
  margin: 36px auto 0;
  border: none;
  background: #12af78;
  color: #fff;
  font-size: 16px;
  line-height: 1;
}

.teacher-home-action i {
  font-size: 26px;
}

.teacher-home-feature {
  padding: 0 0 26px;
  background: #f5f5f5;
}

.teacher-home-feature h2 {
  padding: 18px 8px 16px;
  color: #12a875;
  font-size: 25px;
  font-weight: 800;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 16px 18px 22px;
}

.feature-card {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  align-items: center;
  min-height: 178px;
  padding: 18px 18px 18px 20px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 14px rgba(31, 41, 55, 0.06);
}

.feature-index {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  height: 98px;
  margin-left: 8px;
  background: #14b87e;
  color: #fff;
  font-size: 72px;
  font-weight: 800;
  line-height: 1;
  transform: rotate(45deg);
}

.feature-index span {
  display: block;
  font-family: Arial, sans-serif;
  transform: rotate(-45deg);
}

.feature-content h3 {
  color: #27313d;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
}

.feature-content p {
  margin-top: 6px;
  color: #5f6874;
  font-size: 15px;
  line-height: 1.8;
}

.feature-action {
  margin-top: 0;
}

.teacher-home-teachers {
  position: relative;
  padding: 32px 20px 38px;
  overflow: hidden;
  background:
    radial-gradient(circle at 12% 15%, rgba(255, 192, 51, 0.34) 0 12px, transparent 13px),
    radial-gradient(circle at 80% 12%, rgba(255, 192, 51, 0.3) 0 10px, transparent 11px),
    linear-gradient(180deg, #ffd43a 0%, #ffc715 100%);
}

.teacher-home-teachers::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 235, 160, 0.34) 14px, transparent 14px) 0 0 / 58px 58px,
    linear-gradient(rgba(255, 235, 160, 0.28) 14px, transparent 14px) 18px 18px / 58px 58px;
  opacity: 0.55;
  pointer-events: none;
}

.teacher-stats-banner {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  padding: 16px 18px;
  border-radius: 22px;
  background: #fff;
  box-shadow:
    -12px 16px 0 #f97316,
    0 12px 26px rgba(149, 84, 0, 0.18);
  color: #f97316;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
}

.teacher-source-list {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 34px;
}

.teacher-source-card {
  position: relative;
  min-height: 240px;
  padding: 88px 20px 28px;
  border-radius: 22px;
  background: linear-gradient(180deg, #ff7a00 0%, #ffa500 100%);
  box-shadow: 0 16px 24px rgba(144, 92, 0, 0.28);
}

.teacher-source-card h3 {
  color: #111827;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.5;
}

.teacher-source-icon {
  position: absolute;
  top: -20px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 86px;
  transform: translateX(-50%);
}

.teacher-source-icon.is-board {
  border: 6px solid #fff;
  border-radius: 14px;
  background: #0f7f8b;
  box-shadow: 0 8px 0 rgba(255, 255, 255, 0.25);
}

.teacher-source-icon.is-book {
  width: 116px;
  height: 94px;
}

.teacher-source-icon.is-cap {
  width: 116px;
  height: 80px;
}

.icon-bulb {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff8dc;
}

.icon-bulb::before,
.icon-bulb::after {
  content: '';
  position: absolute;
  left: 50%;
  background: #fff8dc;
  transform: translateX(-50%);
}

.icon-bulb::before {
  bottom: -9px;
  width: 12px;
  height: 12px;
  border-radius: 0 0 6px 6px;
}

.icon-bulb::after {
  top: -14px;
  width: 4px;
  height: 10px;
  box-shadow:
    -18px 14px 0 0 #fff8dc,
    18px 14px 0 0 #fff8dc,
    -12px -2px 0 0 #fff8dc,
    12px -2px 0 0 #fff8dc,
    0 24px 0 0 #fff8dc;
}

.icon-book-stack {
  position: relative;
  width: 100px;
  height: 78px;
}

.icon-book-stack::before,
.icon-book-stack::after,
.icon-book-stack span {
  content: '';
  position: absolute;
  border-radius: 8px;
}

.icon-book-stack::before {
  right: 8px;
  bottom: 10px;
  width: 56px;
  height: 40px;
  background: #89b73f;
  box-shadow: -18px 8px 0 #e7f2c6;
}

.icon-book-stack::after {
  left: 24px;
  top: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 4px solid #36a9c7;
  background: rgba(54, 169, 199, 0.08);
}

.icon-book-stack span {
  left: 10px;
  top: 0;
  width: 44px;
  height: 56px;
  border: 4px solid #fff;
  background: repeating-linear-gradient(
    90deg,
    #f97316 0 5px,
    #fff 5px 12px
  );
  transform: skewY(-18deg);
}

.icon-cap {
  position: relative;
  width: 96px;
  height: 58px;
}

.icon-cap::before,
.icon-cap::after {
  content: '';
  position: absolute;
}

.icon-cap::before {
  top: 0;
  left: 0;
  width: 96px;
  height: 36px;
  background: #1f4b7b;
  clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
  box-shadow: 0 6px 0 #fff;
}

.icon-cap::after {
  top: 28px;
  left: 24px;
  width: 48px;
  height: 18px;
  border-radius: 0 0 12px 12px;
  background: #193b61;
  box-shadow: 32px -10px 0 -6px #ffcc4d;
}

.teacher-home-process {
  padding: 22px 20px 42px;
  background: linear-gradient(180deg, #ffd53f 0%, #f7c617 100%);
}

.process-title-wrap {
  display: flex;
  justify-content: center;
}

.process-title-wrap h2 {
  position: relative;
  padding: 16px 42px;
  border-radius: 18px 18px 8px 8px;
  background: linear-gradient(180deg, #ffb21e 0%, #f59e0b 100%);
  color: #111827;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 1px;
  box-shadow: 14px 0 0 #ea580c;
}

.process-panel {
  margin-top: -8px;
  padding: 28px 18px 18px;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 16px 24px rgba(144, 92, 0, 0.18);
}

.process-row {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 18px 10px 20px;
}

.process-row + .process-row {
  border-top: 3px dashed #fb923c;
}

.process-tag {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 0 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ff7a00 0%, #f97316 100%);
  color: #111827;
}

.process-check {
  position: relative;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ffd400;
  box-shadow: inset 0 0 0 4px #fff;
}

.process-check::after {
  content: '';
  position: absolute;
  top: 7px;
  left: 8px;
  width: 10px;
  height: 6px;
  border-bottom: 3px solid #fff;
  border-left: 3px solid #fff;
  transform: rotate(-45deg);
}

.process-tag strong {
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 2px;
}

.process-row p {
  margin: 0;
  color: #111827;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.7;
}

@media (min-width: 769px) {
  .teacher-home-main {
    padding-top: 0;
  }
}

@media (max-width: 768px) {
  .teacher-source-list {
    grid-template-columns: 1fr;
  }

  .teacher-source-card {
    min-height: auto;
    padding-top: 84px;
  }

  .process-row {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}

@media (max-width: 420px) {
  .teacher-home-hero {
    grid-template-columns: minmax(0, 1fr) 108px;
    min-height: 208px;
  }

  .hero-copy {
    margin-left: 24px;
  }

  .hero-copy h1 {
    font-size: 30px;
  }

  .hero-copy p {
    font-size: 14px;
  }

  .teacher-home-intro {
    padding-right: 30px;
    padding-left: 30px;
  }

  .teacher-home-intro p {
    font-size: 17px;
  }

  .feature-card {
    grid-template-columns: 120px minmax(0, 1fr);
    min-height: 166px;
    padding-right: 14px;
    padding-left: 14px;
  }

  .feature-index {
    width: 88px;
    height: 88px;
    font-size: 64px;
  }

  .feature-content h3 {
    font-size: 18px;
  }

  .teacher-home-teachers {
    padding-right: 16px;
    padding-left: 16px;
  }

  .teacher-stats-banner {
    padding: 14px 12px;
    font-size: 20px;
    box-shadow:
      -8px 12px 0 #f97316,
      0 10px 20px rgba(149, 84, 0, 0.18);
  }

  .teacher-source-card h3 {
    font-size: 17px;
  }

  .process-title-wrap h2 {
    padding: 14px 28px;
    font-size: 24px;
  }

  .process-panel {
    padding-right: 14px;
    padding-left: 14px;
  }

  .process-tag {
    padding-right: 14px;
    padding-left: 14px;
  }

  .process-tag strong {
    font-size: 17px;
    letter-spacing: 1px;
  }

  .process-row p {
    font-size: 15px;
  }
}
</style>
